import CancelSubscriptionModal from '@anm/components/subscription/CancelSubscriptionModal';
import useDependPendingCallback from '@anm/hooks/useDependPendingCallback';
import useDependPendingError from '@anm/hooks/useDependPendingError';
import { useCallback, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { subscriptionActions, subscriptionSelectors } from '../../../store/modules/subscription';
import useUpdateUserInfoHandler from '../../pricing/PricingSubscriptionContent/hooks/useUpdateUserInfoHandler';

export type CancelUserSubscriptionProps = {
  planName: string;
  onModalClose: () => void;
};

const CancelUserSubscription: FC<CancelUserSubscriptionProps> = ({ planName, onModalClose }) => {
  const dispatch = useDispatch();
  const handleInfoUpdate = useUpdateUserInfoHandler();

  const isSubscriptionChangePending = useSelector(subscriptionSelectors.selectSubscriptionChangePending);
  const changeError = useSelector(subscriptionSelectors.selectSubscriptionChangeError);
  const changeErrorLocal = useDependPendingError(isSubscriptionChangePending, changeError);

  const isCancelPending = useSelector(subscriptionSelectors.selectCancelSubscriptionPending);
  const cancelError = useSelector(subscriptionSelectors.selectCancelSubscriptionError);
  const cancelErrorLocal = useDependPendingError(isCancelPending, cancelError);

  const handleBuyStarter = useCallback(() => {
    dispatch(
      subscriptionActions.changeSubscription({
        name: 'WaveStarter',
        period: 'MONTHLY'
      })
    );
  }, []);

  const handleCancel = useCallback(() => {
    dispatch(subscriptionActions.cancelSubscription());
  }, []);

  const handleCloseModal = () => {
    if (!!cancelError || !!changeError) return;
    onModalClose();
  };
  useDependPendingCallback(isSubscriptionChangePending, handleCloseModal);
  useDependPendingCallback(isCancelPending, () => {
    handleInfoUpdate();
    handleCloseModal();
  });

  return (
    <CancelSubscriptionModal
      error={changeErrorLocal?.message || cancelErrorLocal?.message}
      planName={planName}
      isKeepPending={isSubscriptionChangePending}
      isCancelPending={isCancelPending}
      onBuyStarter={handleBuyStarter}
      onCancel={handleCancel}
      onClose={onModalClose}
    />
  );
};
export default CancelUserSubscription;
